import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

import AddApp from '@/assets/icons/AddApp';
import Button from '@/components/Buttons/Button';
import { DashboardStep } from '@/features/Dashboard/constants/DashboardStep';
import { DASHBOARD_ACTION_BUTTON_WIDTH } from '@/features/Dashboard/constants/style';
import { ButtonsContainer } from '@/features/Dashboard/drawer/components/ButtonsContainer';
import { DrawerStep, useDrawerSteps } from '@/features/Dashboard/drawer/context/DrawerStepsContext';
import type { SetState } from '@/types/helpers';

export const DashboardActionButtons = ({
  setStep,
  children
}: {
  setStep: SetState<DashboardStep>;
  children?: React.ReactNode;
}) => {
  const { setDrawerStep } = useDrawerSteps();

  return (
    <ButtonsContainer>
      {children}
      <Button
        color='secondary'
        size='large'
        startIcon={<EditOutlinedIcon />}
        sx={{
          width: DASHBOARD_ACTION_BUTTON_WIDTH
        }}
        variant='contained'
        onClick={() => {
          setStep(DashboardStep.Edit);
        }}
      >
        Edit
      </Button>
      <Button
        color='secondary'
        size='large'
        startIcon={<AddApp fill='#F8F8F8' />}
        sx={{
          width: DASHBOARD_ACTION_BUTTON_WIDTH
        }}
        variant='contained'
        onClick={() => {
          setDrawerStep(DrawerStep.SelectApp);
        }}
      >
        Add app
      </Button>
    </ButtonsContainer>
  );
};
